import React from 'react';
import RouteErrorBoundary from '@app/components/ErrorBoundary';
import { UserUtils } from '@app/modules/userinfo';
import { Endpoints } from '@settings/endpoints-setting';
import { Navigate, RouteObject } from 'react-router-dom';

const NAVIGATE_ROUTE = {
  SSO_AUTH: '/api/auth/sso/login',
  PROJECT: '/project',
  LOADING_MULTIPLE_MODLES: '/loading-multiple-models',
  DUEVIEWER: '/due-viewer',
  HISTORY: '/history',
  COMPARE: '/compare',
  UNIFORMITY: '/uniformity',
  MAINTENANCE: '/maintenance',
  AUTHENTICATION_ERROR: '/authentication-error',
  SERVICETIME: '/servicetime',
  UNAUTHORIZATION: '/unauthorization',
  SYSTEM_ERROR: '/system-error',
  SC001: '/login',
  SC002: '/design/share',
  SC003: '/design/share/status',
  SC004: '/dashboard',
  SC004_DETAIL: '/dashboard/project',
  SC005: '/project/progress',
  SC005_REQUEST: '/project/progress/request',
  SC006: '/design/manage',
  SC007: '/document/manage',
  SC008: '/project/member',
  SC009: '/project/info',
  SC010: '/request/group-setting',
  SC011: '/project/manage',
  SC012: '/request/view',
  SC013: '/user/manage',
  SC014: '/error-code',
  BV001: '/viewer/design/manage',
  BV002: '/viewer/design',
};

const HOME_PATH = '/';

const RootRedirect: React.FC = () => {
  const userId = UserUtils.get()?.user?.userId;
  if (userId) {
    return <Navigate to={NAVIGATE_ROUTE.SC004} replace />;
  }
  window.location.href = `${Endpoints.COMMON.API_ENDPOINT}${NAVIGATE_ROUTE.SSO_AUTH}`;
};

const CONFIGURATION_ROUTE_COMMON: RouteObject[] = [
  {
    path: HOME_PATH,
    element: <RootRedirect />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: '*',
    element: <Navigate to={NAVIGATE_ROUTE.SC014} />,
    errorElement: <RouteErrorBoundary />,
  },
];

enum RouterAccessPermission {
  Public = 'public',
  Private = 'private',
}
const ROUTER_PERMISSION_FOLDER_INDEX = 2;

export {
  CONFIGURATION_ROUTE_COMMON,
  HOME_PATH,
  NAVIGATE_ROUTE,
  ROUTER_PERMISSION_FOLDER_INDEX,
  RouterAccessPermission,
};
